<template>
  <div v-show="isLoaded" class="mFlavors-container" v-observe-visibility="startAnimate">
    <div class="mSection-title">
      <h2 class="title" :class="{animate: animate}">Descubre tu <br class="onlyMobile"><span>Strongbow</span></h2>
      <p class="paragraph" :class="{animate: animate}">Te lleva a conectar con la <br class="onlyMobile"> naturaleza y el sabor de las <br> manzanas a través de sus <br class="onlyMobile"> 4 refrescantes variantes.</p>
    </div>
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide>
        <div class="mflex-container gold">
          <img class="bottle" :src="bottleGold" alt="Botella Gold Apple">
          <div class="mflex-column">
            <h3 class="bottle-title" >GOLD APPLE</h3>
            <p class="bottle-description">
              Sabor fresco con un toque dulce de <br>manzana golden y un acabado suave y elegante.
            </p>
            <p class="bottle-features gold">4.5% ALC. <span class="divider">|</span> GLUTEN FREE</p>
              <router-link class="button" :to="{name: 'mixologiaGold', hash: '#mixologiaGold' }">
                <img :src="button" alt="Boton Gold Apple">
              </router-link>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="mflex-container rose">
          <img class="bottle" :src="bottleRose" alt="Botella Rose Apple">
          <div class="mflex-column">
            <h3 class="bottle-title" >ROSÉ APPLE</h3>
            <p class="bottle-description" >
              Sabor semi seco elaborado de manzanas rosadas y jugo de manzana rojo vibrante, ofreciendo un sabor nuevo y refrescante.
            </p>
            <p class="bottle-features">4.5% ALC. <span class="divider">|</span> GLUTEN FREE</p>
              <router-link class="button" :to="{name: 'mixologiaRose', hash: '#mixologiaRose' }">
                <img :src="button" alt="Boton Rose Apple">
              </router-link>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="mflex-container honey">
          <img class="bottle" :src="bottleHoney" alt="Botella Honey">
          <div class="mflex-column">
            <h3 class="bottle-title" >HONEY</h3>
            <p class="bottle-description" >
              Sabor dulce y refrescante que combina manzana y notas de miel que provoca un dulzor delicado
            </p>
            <p class="bottle-features">4.5% ALC. <span class="divider">|</span> GLUTEN FREE</p>
              <router-link class="button" :to="{name: 'mixologiaHoney', hash: '#mixologiaHoney' }">
                <img :src="button" alt="Boton Honey">
              </router-link>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="mflex-container red">
          <img class="bottle" :src="bottleRed" alt="Botella Red Berries">
            <div class="mflex-column">
              <h3 class="bottle-title" >RED BERRIES</h3>
              <p class="bottle-description" >
                Sabor refrescante que combina manzanas y la explosión de frutos rojos, con notas sutiles de limón.
              </p>
              <p class="bottle-features">4.5% ALC. <span class="divider">|</span> GLUTEN FREE</p>
                <router-link class="button" :to="{name: 'mixologiaRed', hash: '#mixologiaRed' }">
                  <img :src="button" alt="Boton Red Berries">
                </router-link>
            </div>
        </div>   
      </swiper-slide>

<div class="swiper-button-prev" slot="button-prev">
  <div class="arrowSliding">
    <div class="arrow"></div>
  </div>
  <div class="arrowSliding delay1">
    <div class="arrow"></div>
  </div>
  <div class="arrowSliding delay2">
    <div class="arrow"></div>
  </div>

</div>
<div class="swiper-button-next" slot="button-next">
  <div class="arrowSliding next">
    <div class="arrow-next"></div>
  </div>
  <div class="arrowSliding delay1 next">
    <div class="arrow-next"></div>
  </div>
  <div class="arrowSliding delay2 next">
    <div class="arrow-next"></div>
  </div>

</div>
    </swiper>
  </div>
</template>

<script>

import { Swiper, SwiperSlide} from 'vue-awesome-swiper'
import bottleGold from '@/assets/botellas-mobile/GOLD_APPLE.png'
import bottleHoney from '@/assets/botellas-mobile/HONEY.png'
import bottleRed from '@/assets/botellas-mobile/RED_BERRIES.png'
import bottleRose from '@/assets/botellas-mobile/ROSE_APPLE.png'
import brushRose from '@/assets/brush-rose.png'
import brushGold from '@/assets/brush-gold.png'
import brushRed from '@/assets/brush-REDBERRIES.png'
import brushHoney from '@/assets/brush-HONEY.png'
import button from '@/assets/BOTON CONOCE SOBRE MIXOLOGIA.png'
import 'swiper/css/swiper.css'
import Bowser from "bowser"; 

import { mapGetters } from "vuex";
export default {
  name: "Flavors",
  components: {Swiper, SwiperSlide},
  data() {
    return {
      bottleGold,
      bottleRose,
      bottleHoney,
      bottleRed,
      brushRose,
      brushGold,
      brushRed,
      brushHoney,
      button,
      isSafari: false,
      animate: false,
      swiperOptions: {
        slidesPerView: 1,
        centeredSlides: true,
        centeredSlidesBounds: false,
        centerInsufficientSlides	:false,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },

           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
    };
  },
      computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible){
      if(isVisible){
        this.animate=true
      }
      
    }
  },
    beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
}
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Flavors.scss";
</style>
